import PropTypes from 'prop-types';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { ReactComponent as Warning } from '../../assets/icons/warning-static.svg';
import { useUserContext } from '../../context';
import { useEmailVerification } from '../../hooks';
import { useFetchMerchantProfile, useFetchSettlementAccounts } from '../../hooks/queries';
import { Banner } from '../banner';

const NextSteps = ({ hiddenPaths = [] }) => {
  const { user } = useUserContext();
  const { pathname } = useLocation();

  if (hiddenPaths.some((p) => pathname.startsWith(p))) return null;

  const { isKycVerified } = user;
  const { userHasSettlementAccounts } = useFetchSettlementAccounts();
  const { userHasVerifiedEmail } = useFetchMerchantProfile();

  return (
    <>
      {!userHasVerifiedEmail && <VerifyEmailBanner />}
      {!userHasSettlementAccounts && userHasVerifiedEmail && <CreateSettlementAccountBanner />}
      {!isKycVerified && <KycBanner />}
    </>
  );
};

const VerifyEmailBanner = () => {
  const { isLoading, emailVerification } = useEmailVerification();
  return (
    <Banner>
      <>
        <Warning />
        <p>
          You’re one step away from accepting crypto payments.{' '}
          {isLoading ? (
            `Verifying...`
          ) : (
            <>
              Kindly verify your{' '}
              <span
                role="button"
                onClick={emailVerification}
                onKeyDown={emailVerification}
                tabIndex="0"
                className="cta">
                <b>email address</b>
              </span>
            </>
          )}
        </p>
      </>
    </Banner>
  );
};

VerifyEmailBanner.propTypes = {
  email: PropTypes.string
};

const CreateSettlementAccountBanner = () => {
  return (
    <Banner>
      <>
        <Warning />
        <p>
          <Link to="/settings/settlement">
            <b>Create a settlement account</b>
          </Link>{' '}
          to start accepting crypto payments now.
        </p>
      </>
    </Banner>
  );
};

const KycBanner = () => {
  return (
    <Banner>
      <>
        <Warning />
        <p>
          To get started with basqet, we require some important information to access your identity.{' '}
          <Link to="/onboard">Start verification</Link>{' '}
        </p>
      </>
    </Banner>
  );
};

NextSteps.propTypes = {
  hiddenPaths: PropTypes.arrayOf(PropTypes.string)
};

export { NextSteps };
